import React, {Component} from 'react'
import {Card, CardBody, CardHeader} from "reactstrap"
import {getCommitTimesStatistics} from "../../services/api/apiNextBox"
import {Link} from "react-router-dom"

class OvertimedStatistics extends Component {
    state = {
        data: [],
        error: '',
        loading: false
    }

    componentDidMount() {
        this._getData()
    }

    _getData = async () => {
        this.setState({
            loading: true,
            error: ''
        })

        try {
            const {success, data, message} = await getCommitTimesStatistics()

            if (!success) {
                this.setState({
                    error: message,
                    loading: false
                })
            }

            this.setState({
                data: data,
                loading: false
            })
        } catch (e) {
            this.setState({
                loading: false,
                error: e.message
            })
        }
    }

    _calculatorTotalArray = (arrTotal) => {
        return arrTotal.reduce(
            ( accumulator, currentValue ) => accumulator + currentValue,
            0
        )
    }

    render() {
        const {data, error, loading} = this.state
        const arrOvertime1day = (data !== undefined && data.length > 0) ? data.map(item => item.overtime_1_day) : []
        const arrOvertime2day = (data !== undefined && data.length > 0) ? data.map(item => item.overtime_2_day) : []
        const arrOvertime3day = (data !== undefined && data.length > 0) ? data.map(item => item.overtime_3_day) : []
        const arrOvertime4day = (data !== undefined && data.length > 0) ? data.map(item => item.overtime_4_day) : []
        const arrOvertimeAll = (data !== undefined && data.length > 0) ? data.map(item => (item.overtime_1_day + item.overtime_2_day + item.overtime_3_day + item.overtime_4_day)) : []

        return (
            <div className="PackingStatistics">
                <Card>
                    <CardHeader className="bg-warning text-white header-elements-inline">
                        <h2 className="card-title"><i className="icon-calendar"/> Thời gian quá hạn</h2>
                    </CardHeader>

                    <CardBody>
                        {error && (
                            <div className="">{error}</div>
                        )}
                        <table className="table">
                            <thead>
                            <tr>
                                <th>Type</th>
                                <th>Quá hạn 1 ngày</th>
                                <th>Quá hạn 2 ngày</th>
                                <th>Quá hạn 3 ngày</th>
                                <th>Quá hạn 4 ngày</th>
                                <th>Tổng </th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                (data !== undefined && data.length > 0 && !loading) && (
                                    <tr className="totalColumns">
                                        <td><strong>Tổng số</strong></td>
                                        <td><strong>
                                            <Link
                                                to={{
                                                    pathname: "/admin",
                                                    search: `?products.overtimeGt=0&products.overtimeLte=1`
                                                }}
                                            >
                                            {this._calculatorTotalArray(arrOvertime1day)}
                                            </Link>
                                        </strong></td>
                                        <td><strong>
                                            <Link
                                                to={{
                                                    pathname: "/admin",
                                                    search: `?products.overtimeGt=1&products.overtimeLte=2`
                                                }}
                                            >
                                                {this._calculatorTotalArray(arrOvertime2day)}
                                            </Link>
                                        </strong></td>
                                        <td><strong>
                                            <Link
                                                to={{
                                                    pathname: "/admin",
                                                    search: `?products.overtimeGt=2&products.overtimeLte=3`
                                                }}
                                            >
                                                {this._calculatorTotalArray(arrOvertime3day)}
                                            </Link>
                                        </strong></td>
                                        <td><strong>
                                            <Link
                                                to={{
                                                    pathname: "/admin",
                                                    search: `?products.overtimeGt=3`
                                                }}
                                            >
                                                {this._calculatorTotalArray(arrOvertime4day)}
                                            </Link>
                                        </strong></td>
                                        <td><strong>
                                            <Link
                                                to={{
                                                    pathname: "/admin",
                                                    search: `?products.overtime=y`
                                                }}
                                            >
                                                {this._calculatorTotalArray(arrOvertimeAll)}
                                            </Link>
                                        </strong></td>
                                    </tr>
                                )
                            }
                            {loading ? (
                                <tr>
                                    <td colSpan={6}>Đang tải ...</td>
                                </tr>
                            ) : (
                                data !== undefined && data.length > 0 ? (
                                    data.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>
                                                    <Link
                                                        to={{
                                                            pathname: "/admin",
                                                            search: `?products.type=${item.type}&products.overtime=y`
                                                        }}
                                                    >
                                                        {item.type}
                                                    </Link>
                                                </td>
                                                <td>
                                                    <Link
                                                        to={{
                                                            pathname: "/admin",
                                                            search: `?products.type=${item.type}&products.overtimeGt=0&products.overtimeLte=1`
                                                        }}
                                                    >
                                                        {item.overtime_1_day}
                                                    </Link>
                                                </td>
                                                <td>
                                                    <Link
                                                        to={{
                                                            pathname: "/admin",
                                                            search: `?products.type=${item.type}&products.overtimeGt=1&products.overtimeLte=2`
                                                        }}
                                                    >
                                                        {item.overtime_2_day}
                                                    </Link>
                                                </td>
                                                <td>
                                                    <Link
                                                        to={{
                                                            pathname: "/admin",
                                                            search: `?products.type=${item.type}&products.overtimeGt=2&products.overtimeLte=3`
                                                        }}
                                                    >
                                                        {item.overtime_3_day}
                                                    </Link>
                                                </td>
                                                <td>
                                                    <Link
                                                        to={{
                                                            pathname: "/admin",
                                                            search: `?products.type=${item.type}&products.overtimeGt=3`
                                                        }}
                                                    >
                                                        {item.overtime_4_day}
                                                    </Link>
                                                </td>
                                                <td>
                                                    <Link
                                                        to={{
                                                            pathname: "/admin",
                                                            search: `?products.type=${item.type}&products.overtime=y`
                                                        }}
                                                    >
                                                        {item.overtime_1_day + item.overtime_2_day + item.overtime_3_day + item.overtime_4_day}
                                                    </Link>
                                                    </td>
                                            </tr>
                                        )
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan={5}>Không có dữ liệu</td>
                                    </tr>
                                )
                            )}
                            </tbody>
                        </table>
                    </CardBody>
                </Card>
            </div>
        )
    }
}

export default OvertimedStatistics